<template>
  <a-modal 
    :visible="visibles" 
    :title="detail.productName"
    :width="1100"
    @ok="ok"
    :footer="false"
    v-if="visibles"
    :bodyStyle="{padding:'10px'}"
    :forceRender="true"
    @cancel="cancel"
  >
    <div class="cols">
      <div :span="8" class="col-item">
        <div class="col-item-title">产品初始价格({{raw.formulaProductPricesInfo.createDate}})</div>
        <div class="value">{{pricer.initPrice.toFixed(3) || 0.000}}<span>元/吨</span></div>
      </div>
      <div :span="8" class="col-item">
        <div class="col-item-title">最新产品价格({{raw.formulaProductPricesInfo.newestDate}})</div>
        <div class="value">{{pricer.newestPrice.toFixed(3)   || 0.000}} <span>元/吨</span></div>
      </div>
      <div :span="8" class="col-item">
        <div class="col-item-title">差异</div>
         <div  class="value">
            <i :class="{red:raw.formulaProductPricesInfo.diffPrice > 0,green:raw.formulaProductPricesInfo.diffPrice<0,display:'inline'}">
               <a-icon style="font-size:24px" v-if="pricer.diffPrice!= 0" :type="priceType" /> 
               {{pricer.diffPrice === 0 ? '-' : pricer.diffPrice.toFixed(3)}}
            </i>
          <span>元/吨</span>
        </div>
      </div>
    </div>
    <a-tabs  v-if="raw" @change="tabChange"  :activeKey="tabSelect" :animated="false" >
      <a-tab-pane key="0" tab="原料">
        <a-table
        :scroll="{ x: 0, y: 400 }" 
        :columns="rawColumns"
        :pagination="false"
        :row-key="record => record.id"
        :rowClassName="rowClassname"
        :dataSource="raw.formulaRawProductVOList">
        <template slot="rawName" slot-scope="text,record">
          {{overseasFlag == '1' ? (record.aliasName || text) : text}}
        </template>
          <div slot="diffPrice" slot-scope="text,record" :class="{red:record.newestPrice > record.price,green:record.newestPrice < record.price}">
             <a-icon style="font-size:12px" v-if="record.price != record.newestPrice" :type="record.newestPrice > record.price ? 'arrow-up' : 'arrow-down'" /> 
             {{text ? text.toFixed(3) : text}}
          </div>
          <template
            v-for="col in ['percentage','uasge','price','content','newestPrice']" 
            slot-scope="text" 
            :slot="col">
            <span :key="col">{{text!== null ? text.toFixed(3) : text}}</span>
          </template>
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="1" tab="营养分析">
        <a-table
        :pagination="false"
        :dataSource="nut"
        :row-key="record => $uid()"
        :scroll="{ x: 0, y: 400 }"
         :columns="nutColumns">
          <template slot="content" slot-scope="text,record">
            {{text != null ? text.toFixed(record.unit ==='' || record.unit === 'Kcal' ? 0 : 2) : text}}
          </template>
         </a-table>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script>
import { productMixins } from '../unitls'
import columns from './columns'

export default {
  mixins:[productMixins],
  props:['hidden'],
  data(){
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      raw:{
        formulaProductPricesInfo:{}
      },
      nut:[],
      detail:{},
      tabSelect:"0",
      ...columns
    }
  },
  computed:{

    pricer(){
      const {numberText} = this
      let price = {initPrice:0,newestPrice:0,diffPrice:0}
      if(this.raw && this.raw.formulaProductPricesInfo){
      const {initPrice,newestPrice,diffPrice} = this.raw.formulaProductPricesInfo
        price = {initPrice:numberText(initPrice),newestPrice:numberText(newestPrice),diffPrice:numberText(diffPrice)}
      }
       return price
    },
    visibles(){
      return this.hidden ? true : false
    },
    unitPrice(){
      const {price,lastPrice} = this.detail
      return this.sub((price || 0) - (lastPrice || 0))
    },
    priceType(){
      return this.raw.formulaProductPricesInfo.diffPrice > 0 ? 'arrow-up' : 'arrow-down'
    }
  },
  watch:{
    hidden(id){
      if(id){
        this.getDetail({id})
        this.rawList({id})
        this.nutList({id})
      }else{
        this.tabSelect = "0"
      }
    }
  },
  methods:{
    rowClassname(record){
      return record.isRawDelete == '1' ? 'selectGary' : ''
    },
    ok(){
      this.$emit('ok')
    },
    cancel(){
      this.$emit('cancel')
    },
    async getDetail(data){
      await this.fetchGet({
        name:'detail',
        data,
        actions:this.formulaproductDetail,
        loading:'detailLoading'
      })
    },

    tabChange(val){
      this.tabSelect = val
    },
    async rawList({id,...arg}){
      await this.fetchGet({
        name:'raw',
        actions:this.selectFormulaProductRawByProductId,
        data:{
          productId:id,
          size:1000,
          ...arg
        }
      })
    },
    async nutList({id,...arg}){
      this.fetchGet({
        actions:this.selectFormulaProductNutritionByProductId,
        name:'nut',
        data:{
          productId:id,
          size:1000,
          ...arg
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .cols{
    padding:15px 20px;
    display: flex;
    align-items: center;
    
  }
  .col-item{
      width: 33.333333%;

      &-title{
        font-size: 12px;
        color:#777;
      }
    }
  .value{
    font-size:28px;
    font-weight: 700;
      display: flex;
      align-items: center;
    i{
      font-style: normal;
      display: flex;
      align-items: center;
    }
    span{
    margin-left: 5px;
    font-weight: normal;
      font-size:12px;
    }
  }
  .green{color:green}
  .red{color:red}
</style>
<style lang="scss" scoped>
  ::v-deep .selectGary{
    background-color: rgba(130, 130, 130, 0.1) !important;
  }
</style>